import Vue from "vue";

function getJSONFromLocalStorage(item_key) {
  try {
    return JSON.parse(localStorage.getItem(item_key));
  } catch (_) {
    return undefined;
  }
}


export default {
  namespaced: true,
  state: {
    auto_convert_money: true,
    raw_breadcrumb: [],
    vue_bootstrap_breadcrumb: [],
    country_fields: [
      { value: "MX", langkey: "global.country_field_mx" },
      { value: "US", langkey: "global.country_field_us" },
      { value: "ES", langkey: "global.country_field_es" },
    ],
    cookies_accepted:
    process.browser
      ? getJSONFromLocalStorage("cookies_accepted") || false
      : undefined,
    home_video_displayed: false,
  },
  actions: {
    CHANGE_BREADCRUMB: ({ commit }, breadcrumb) => {
      commit("MUTATE_BREADCRUMB", breadcrumb);
    },
  },
  mutations: {
    MUTATE_BREADCRUMB: (state, payload) => {
      Vue.set(state, "raw_breadcrumb", payload);
      // console.log('breadcrumb:');
      // console.log(payload);
      // if (Array.isArray(payload)) {
      //   var vue_bot_bread = [];
      //   payload.forEach(function(item){
      //     vue_bot_bread.push({
      //         text: item.langkey,
      //         href: item.path
      //     });
      //   });
      //   Vue.set(state, 'vue_bootstrap_breadcrumb', vue_bot_bread);
      // }
    },
    MUTATE_ACCEPT_COOKIES: (state, payload) => {
      Vue.set(state, "cookies_accepted", payload);
      localStorage.setItem("cookies_accepted", payload);
    },
    MUTATE_HOME_VIDEO_DISPLAYED: (state, payload) => {
      Vue.set(state, "home_video_displayed", payload);
    },
  },
  getters: {
    raw_breadcrumb: state => {
      return state.raw_breadcrumb;
    },
  },
};
